import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { A } from '~/__modules__/browser';
import { ServiceURL } from '~/__modules__/env';

ServicesMenu.propTypes = {
  services: PropTypes.array,
};

export function ServicesMenu({ services = [] }) {
  const { t } = useTranslation();

  const hasWPService = (serviceKeys) =>
    serviceKeys.some((key) =>
      ['approval_web', 'reservation_web', 'mywork_web', 'support_web'].includes(
        key,
      ),
    );

  const serviceConfig = [
    {
      title: t('home_main_title'),
      key: 'home_web',
      desc: t('noti_main_homeguide'),
      path: `${ServiceURL.BOARD}/settings/notify`,
    },
    {
      title: t('message_main_title'),
      key: 'message_web',
      desc: t('noti_main_messageguide'),
      path: `/settings/notify`,
    },
    {
      title: t('mail_main_title'),
      key: 'mail_web',
      desc: t('noti_main_mailguide'),
      path: `${ServiceURL.MAIL}/settings/notify`,
    },
    {
      title: t('calendar_main_title'),
      key: 'calendar_web',
      desc: t('noti_main_calguide'),
      path: `${ServiceURL.CALENDAR}/settings/notify`,
    },
    {
      title: t('task_main_title'),
      key: 'task_web',
      desc: t('noti_main_taskguide'),
      path: `${ServiceURL.TASK}/settings/notify`,
    },
    {
      title: t('drive_main_title'),
      key: 'drive_web',
      desc: t('noti_main_driveguide'),
      path: `${ServiceURL.DRIVE}/settings/notify`,
    },
    {
      title: t('form_main_title'),
      key: 'form_web',
      desc: t('noti_main_formguide'),
      path: `${ServiceURL.FORM}/settings/notify`,
    },
    {
      title: t('support_main_title'),
      key: 'wp_web',
      desc: t('support_main_guide'),
      path: `${ServiceURL.WORKPLACE_URL}/_sc/user/noti-set`,
      hasPopuplink: true,
    },
  ];

  const serviceKeys = [...services];
  if (hasWPService(serviceKeys)) serviceKeys.push('wp_web');

  const serviceMenuList = serviceConfig
    .map((item) => {
      if (serviceKeys.includes(item.key)) return item;
    })
    .filter((item) => item);

  return (
    serviceMenuList.length > 0 && (
      <>
        <h3 className="title">
          <span className="text">{t('noti_main_serviceset_title')}</span>
        </h3>
        <ul className="settings_list">
          {serviceMenuList.map((item) => (
            <li
              className={`item ${
                item.hasPopuplink ? 'has_popup_link' : 'has_link'
              }`}
              key={item.key}
            >
              <div className="title_area">
                <h4 className="title">
                  <span className="text">{item.title}</span>
                </h4>
                <p className="desc">{item.desc}</p>
              </div>
              <A
                href={item.path}
                className="link_more"
                target={item.hasPopuplink && '_blank'}
              >
                <i className="blind">go to detail</i>
              </A>
            </li>
          ))}
        </ul>
      </>
    )
  );
}
